// @ts-nocheck
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import Input from 'antd/lib/input';
import { RangePicker } from '../../../components/ui';
import { Filter, FilterButtonsContainer, FilterContainer, FilterItem, Selects } from './../../../components';
import Field from './../../../components/card/Field';
import { formatDateTimeToISOString } from './../../../lib/helpers';
const {
  BioTreatmentFacilityFactStatusSelect,
  ChannelSelect
} = Selects;
const SpoilerContent = styled.div.withConfig({
  displayName: "Filter__SpoilerContent",
  componentId: "sc-1gab2j2-0"
})(["padding:16px;"]);
export const ContractFilter = ({
  filter,
  cleanFilter,
  applyFilter
}) => <SpoilerContent>
    <FilterContainer>
      <Filter cleanFilter={cleanFilter} applyFilter={applyFilter} initialValues={filter} additionalFilter>
        {({
        values,
        changeValue,
        applyFilter,
        cleanFilter,
        showAdditional,
        handleAdditional
      }) => <>
            <FilterItem>
              <Field mBottomNone>
                <Input size="small" placeholder="Номер ТС" onChange={e => changeValue('licensePlate', e.target.value)} value={values.licensePlate} />
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <BioTreatmentFacilityFactStatusSelect size="small" onChange={value => changeValue('status', value)} value={values.status} />
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <RangePicker size="small" startDate={values.startDate ? moment.utc(values.startDate) : null} endDate={values.endDate ? moment.utc(values.endDate) : null} onChange={changeValue} />
              </Field>
            </FilterItem>

            <FilterItem>
              <Field mBottomNone>
                <ChannelSelect size="small" onChange={value => changeValue('channelId', value)} value={values.channelId} />
              </Field>
            </FilterItem>

            <FilterButtonsContainer applyFilter={applyFilter} cleanFilter={cleanFilter} handleAdditional={handleAdditional} showAdditional={showAdditional} />
          </>}
      </Filter>
    </FilterContainer>
  </SpoilerContent>;
export default ContractFilter;
